const faqs = [
  {
    q: '春夜影院需要注册才能观看吗？',
    a: '不需要。春夜影院坚持"打开即看"的理念，所有影视内容均可免费在线观看，无需注册账号，无需绑定手机或邮箱，没有任何门槛。',
  },
  {
    q: '视频播放会卡顿吗？对网络有什么要求？',
    a: '我们部署了智能 CDN 加速和多节点分发系统，绝大多数用户在普通宽带环境下即可流畅播放。建议 4Mbps 以上带宽以获得 1080P 最佳体验，蓝光画质建议 10Mbps 以上。',
  },
  {
    q: '片源更新频率是怎样的？',
    a: '我们保持每日更新的节奏。热播剧集一般在播出后 24 小时内上线，电影方面院线下映后会尽快更新高清版本资源，确保你能第一时间看到想看的内容。',
  },
  {
    q: '支持哪些设备观看？画质有哪些选择？',
    a: '支持电脑、平板、手机等主流设备访问，页面自动适配屏幕尺寸。画质提供标清、高清 720P、全高清 1080P 以及蓝光 4K 多种选择，可根据网络状况自由切换。',
  },
  {
    q: '春夜影院的资源是否正版？观看安全吗？',
    a: '我们重视内容合规与用户安全。平台所有资源均来自正规合作渠道，播放页面无弹窗广告和恶意跳转，确保观影过程安全无忧。如遇侵权内容请通过联系渠道反馈，我们将及时处理。',
  },
];

export default function FaqSection() {
  return (
    <section id="faq" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            常见问题
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-2xl mx-auto">
            关于春夜影院，你想知道的都在这里
          </p>
        </div>

        <div className="max-w-3xl mx-auto space-y-4">
          {faqs.map((faq, idx) => (
            <div key={idx} className="bg-background-50 rounded-lg p-5 md:p-6">
              <h3 className="font-heading text-base md:text-lg font-semibold text-foreground-950 mb-3 flex items-start gap-3">
                <span className="text-accent-500 shrink-0 mt-0.5">
                  <i className="ri-question-answer-line text-lg"></i>
                </span>
                {faq.q}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed pl-9">
                {faq.a}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}